import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { deleteClassificacaoById, fetchAllClassificacoesByReino } from '../../../store/Classificacao/classificacaoSlice';
import DynamicTable from '@atlaskit/dynamic-table';
import Modal from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import { H3 } from '../Tipografia/Texto';
import { MembroUnidadeGetAllItemDTO } from 'model/reino/MembroUnidadeGetAllItemDTO';
import { PapelMembro } from 'model/seguranca/PapelMembro';
import { fetchMembrosUnidades } from 'store/MembroUnidade/membroUnidadeSlice';
import dayjs, { Dayjs } from 'dayjs';
import { MembroUnidadeDTO } from 'model/reino/MembroUnidadeDTO';

interface MembroUnidadeTableProps {
  onEdit: (responsavel: MembroUnidadeDTO) => void;
}

const MembroUnidadeTable: React.FC<MembroUnidadeTableProps> = ({ onEdit }) => {
  const dispatch = useDispatch();
  const responsaveis = useSelector((state: RootStateOrAny) => state?.membroUnidade.data); 

  console.log("Tabela: ", responsaveis);

  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [deleteMembroUnidadeId, setDeleteMembroUnidadeId] = useState<number | null>(null);


  useEffect(() => {
    
      dispatch(fetchMembrosUnidades());
    
  }, [dispatch]);

  const handleDeleteConfirmation = (id: number) => {
    setDeleteMembroUnidadeId(id);
    setDeleteConfirmationOpen(true);
  };

  const handleDelete = () => {
    if (deleteMembroUnidadeId) {
      (async () => {
        await dispatch(deleteClassificacaoById(deleteMembroUnidadeId));
        dispatch(fetchMembrosUnidades());
        setDeleteConfirmationOpen(false);
      })();
    }
  };

  const handleCloseDeleteConfirmation = () => {
    setDeleteConfirmationOpen(false);
  };

  const head = {
    cells: [
      { key: 'id', content: 'ID', isSortable: true },
      { key: 'nome', content: 'Nome', isSortable: true },
      { key: 'unidade', content: 'Unidade', isSortable: true },
      { key: 'papelMembro', content: 'Papel', isSortable: true },
      { key: 'dataInicio', content: 'Data Início', isSortable: true },
      { key: 'dataFim', content: 'Data Fim', isSortable: true },
      { key: 'actions', content: 'Ações' },
    ],
  };

  const rows = responsaveis.map((responsavel: { id: number; nome: any; idInstitucional: any; papelMembro: PapelMembro; unidade: any; dataInicio: any; dataFim?: any;}) => {
    const isDataFimNotNull = responsavel.dataFim !== null;
  
    return {
      key: `row-${responsavel.id}`,
      cells: [
        { key: responsavel.id, content: responsavel.id },
        { key: responsavel.nome, content: responsavel.nome },
        { key: responsavel.unidade, content: responsavel.unidade.nome },
        { key: responsavel.papelMembro, content: responsavel.papelMembro.nome },
        {
          key: responsavel.dataInicio,
          content: responsavel.dataInicio ? dayjs(responsavel.dataInicio).format('DD/MM/YYYY') : '',
          className: isDataFimNotNull ? 'highlighted-cell' : '',
        },
        {
          key: responsavel.dataFim,
          content: responsavel.dataFim ? dayjs(responsavel.dataFim).format('DD/MM/YYYY') : '',
          className: isDataFimNotNull ? 'highlighted-cell' : '',
        },
        {
          key: 'actions',
          content: (
            <>
              <Button appearance="subtle" onClick={() => onEdit(responsavel)}>
                Editar
              </Button>
              <Button appearance="subtle" onClick={() => handleDeleteConfirmation(responsavel.id)}>
                {responsavel.dataFim ? 'Ativar' : 'Desativar'}
              </Button>
            </>
          ),
        },
      ],
    };
  });
  return (
    <div>
      <H3>Usuários</H3>
      <DynamicTable
        head={head}
        rows={rows}
        rowsPerPage={20}
        defaultPage={1}
        loadingSpinnerSize="large"
        
        isFixedSize
        defaultSortKey="id"
        defaultSortOrder="ASC"
        onSort={() => { }}
        onSetPage={() => { }}
      />

      {deleteConfirmationOpen && (
        <Modal
          heading="Confirmação de exclusão"
          appearance="danger"
          onClose={handleCloseDeleteConfirmation}
          actions={[
            { text: 'Excluir', onClick: handleDelete },
            { text: 'Cancelar', onClick: handleCloseDeleteConfirmation },
          ]}
        >
          <p>Tem certeza de que deseja excluir esta classificação?</p>
        </Modal>
      )}
    </div>

  );
};

export default MembroUnidadeTable;
